import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 12 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 18\" id=\"back\"><path d=\"M11.97 2.116V.304a.187.187 0 0 0-.303-.148L1.1 8.41a.747.747 0 0 0 0 1.179l10.566 8.252c.124.096.302.01.302-.148v-1.811a.38.38 0 0 0-.143-.296L3.39 9l8.437-6.588a.38.38 0 0 0 .143-.295Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol